export enum DataManagementTypes {
    CompanyFootprint
}
export enum CompanyInfoField {
    Source = 'source',
    Description = 'description',
    Year = 'year',
    Modal = 'modal'
}

export enum IsEYPresence {
    offLabel = 'No',
    onLabel = 'Yes'
}
